
import { useParams } from 'react-router-dom'
import { FormBuilderContainer } from '../../../components/formBuilder/formBuilder.container'
import { FormItemTypes, IFormBuilder, ValueTypes } from '../../../components/formBuilder/formBuilder.entity'
import { createMenuGroup, getMenuGroupbyId, updateMenuGroup } from './apiCall'
import { MenuGroupKeys } from './entity'
import { ListKeys, modulesList } from '../../../api/list'

export default function MenuGroupEdit() {
  let { id } = useParams();

  const formData: IFormBuilder['formData'] = [
    {
      type: FormItemTypes.TextInput,
      name: 'Name',
      label: 'Name',
      value: null,
      required: true,
      maxLength: 100,
      valueTypes: ValueTypes.onlyAlphabets
    },
    {
      type: FormItemTypes.TextInput,
      name: 'DisplayName',
      label: 'Display Name',
      value: null,
      required: true,
      maxLength: 100,
      valueTypes: ValueTypes.onlyAlphabets
    },
    {
      type: FormItemTypes.TextInput,
      name: 'LogoPath',
      label: 'Logo Path',
      value: null,
      required: true,
      maxLength: 100,
      valueTypes: ValueTypes.urlPath
    },
    {
      type: FormItemTypes.NumberInput,
      name: 'Sequence',
      label: 'Sequence',
      value: null,
      required: true,
      maxLength: 3,
      valueTypes: ValueTypes.number
    },
    // {
    //   type: FormItemTypes.SearchSelect,
    //   name: 'ModuleId',
    //   label: 'Module',
    //   value: null,
    //   displayExpr: "DisplayName",
    //   valueExpr: "id",
    //   getListData: modulesList,
    //   apiKey: ListKeys.modules,
    //   required: true,
    //   disabled: !!id
    // },
  ]

  return (
    <FormBuilderContainer
      formData={formData}

      getFormAPI={getMenuGroupbyId}
      getRequest={{ id: id }}
      getKey={MenuGroupKeys.get}

      createFormAPI={createMenuGroup}
      createKey={MenuGroupKeys.create}

      updateFormAPI={updateMenuGroup}
      updateKey={MenuGroupKeys.update}

      headerLabel={!id ? 'Add Menu Group' : 'Menu Group'}
      parentPath={'/menuGroup'}
    />
  )
}